<script lang="ts">
  export let text = '';
  export let isExpanded = false;
  export let expand = () => null;
</script>

<div
  class="expander {isExpanded ? 'expander--expanded' : null}"
  style={text ? null : 'justify-content: center'}
  on:click={() => expand()}
>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="var(--hint-400)">
    <path d="M24 30.75 12 18.75 14.15 16.6 24 26.5 33.85 16.65 36 18.8Z"/>
  </svg>
  {#if text}<span contenteditable="false" bind:innerHTML="{text}"></span>{/if}
</div>
